import React, { useEffect } from 'react'
import $ from 'jquery'
import "../css/Skills.css"
import SVG3DTagCloud from '3d-word-cloud';
import Navbar from './Navbar';

function Skills() {
    useEffect(() => {
        $(document).ready(function () {
            var entries = [
                { label: 'HTML' },
                { label: 'CSS' },
                { label: 'Javascript' },
                { label: 'ReactJS' },
                { label: 'NodeJS' },
                { label: 'ExpressJS' },
                { label: 'MongoDB' },
                { label: 'Mongoose' },
                { label: 'SQLite' },
                { label: 'C' },
                { label: 'C++' },
                { label: 'Jquery' },
                { label: 'XML' },
                { label: 'Java' },
                { label: 'Deep Learning' },
                { label: 'Kotlin' },
                { label: 'Machine Learning' },
                { label: 'Python' },
                { label: 'Android Studio' }
            ]

            var settings = {
                entries: entries,
                width: 640,
                height: 480,
                radius: "65%",
                radiusMin: 75,
                bgDraw: true,
                bgColor: "rgba(0,0,0,0)",
                opacityOver: 1.00,
                opacityOut: 0.05,
                opacitySpeed: 6,
                fov: 800,
                speed: 0.5,
                fontFamily: 'Poppins, sans-serif',
                fontSize: "30",
                fontColor: "yellow",
                // fontWeight: "bold",
                // fontFamily: 'poppins',
                fontStyle: "normal",
                fontStretch: "normal",
                fontToUpperCase: false
            }
            SVG3DTagCloud(document.getElementById('tag'), settings)
        })
    }, [])
    return (
        <div className="skills">
            skills
            <div id="tag">
            </div>
        </div>
    )
}

export default Skills